import React from "react";
import css from "./LogoKP.module.scss";
// import LogoKP from "./LogoL_White.svg";

const LogoKP = ({ logo }) => {
    return (
        <img
            style={{ maxHeight: "55px" }}
            src={`${window.location.origin}/${logo}`}
            alt=""
        />
    );
};
export default LogoKP;

export const LogoNavBar = ({ logo }) => {
    return (
        <img
            style={{ maxHeight: "55px" }}
            src={`${window.location.origin}/${logo}`}
            alt=""
        />
    );
};
